import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Get from "../../api/Get";
import { CHECK_LINK } from "../../api/Routes";
import NoDataToShow from "../../components/NoDataToShow";
import LoadingList from "../../loader/LoadingList";
import { Container } from "react-bootstrap";
import { getTokenExternal } from "../../utils/getTokenExternal";

export default function CheckTokenConferencia(){
    const {token} = useParams()
    const [textLoading, setTextLoading] = useState('Validando datos de la cita');
    const [estado, setEstado] = useState("loading")

    const checkEndPointApi = async () => {
        try {
            const tokenData = await getTokenExternal();
            //console.log(tokenData)
            const response = await Get({url: `${CHECK_LINK}/${token}`, access_token: tokenData.data.access_token})
            //console.log(response)
            if(response.data.state){
                window.location.href=response.data.data.response.url
            }else{
                setEstado('notFoundAppointment')
            }
        } catch (error) {
            setEstado('notFoundAppointment')
        }
    }

    useEffect(() => {
        checkEndPointApi()
    }, [])

    //controlador de interfaces
    const estadosMap = {
        loading: <LoadingList texto={textLoading} />,
        notFoundAppointment: <NoDataToShow text="Lo sentimos no podemos encontrar una cita con estos datos"/>,
    }

    return (
        <div className="content mh-100vh">
            <Container fluid className="py-5">
                {
                    estadosMap[estado]
                }
            </Container>
        </div>
    )
}